import { VideoListTable } from "./VideoListTable";
import submit from "submit-form";
import { useState, useEffect } from "react";
import DateInput from "../../../parts/inputs/date-input";
import moment from "moment";
import NavigationComponent from "./components/NavigationComponent";
import { AthleteLinks } from "../../../parts/athlete-links";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import FilterChips from "./FilterChips";
import getAvatarUrl from "../../../utils/get-avatar-url";
import { ReportsBackHandler } from "./components/ReportsBackHandler";
import { IndependentDateRangeComponent } from "./components/IndependentDateRangeComponent";
import CompareSelected from "../../../parts/CompareSelected";
import SvgIcon from "../../../parts/SvgIcon";

const VideoList = ({ locals, momentTZ, comesFromCheckInSummary }) => {
  const { query } = locals;

  const videoLocals = locals.videoListMetrics
    ? locals.videoListMetrics.exercises
    : [];
  const { pathname, athlete } = locals;
  const [counter, setCounter] = useState(1);
  const [selectedRange, setSelectedRange] = useState();
  const [compareState, setCompareState] = useState(false);
  const [videosToCompareState, setVideosToCompareState] = useState([]);
  const [previousExercises, setPreviousExercises] = useState([]);
  const [initialDateState, setInitialDateState] = useState(
    moment.utc(moment().subtract(1, "year")).toDate()
  );
  const [endDateState, setEndDateState] = useState(
    moment.utc(moment().format("MMM DD, YYYY")).toDate()
  );
  const [startDateToShow, setStartDateToShow] = useState(
    query.fromDate
      ? moment(query.fromDate)
      : moment().subtract(1, "year").format("MMM DD, YYYY")
  );
  const [endDateToShow, setEndDateToShow] = useState(
    query.toDate ? moment(query.toDate) : moment()
  );
  const [sortState, setSortState] = useState(-1);
  const [videosToShow, setVideosToShow] = useState([]);
  const [videosToFilter, setVideosToFilter] = useState([]);

  const handleSortChange = ({ target }) => {
    let ordered = [];
    let arrayToOrder = [];
    videosToShow.forEach((element) => {
      arrayToOrder.push(element);
    });
    if (target.value.includes("-")) {
      ordered = arrayToOrder.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
    } else {
      ordered = arrayToOrder.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
    }

    setVideosToShow(ordered);
  };

  // When selected range is changed, we will set the new start date based on the amount of weeks selected
  useEffect(() => {
    // this ensures that a range was selected
    if (selectedRange || selectedRange === 0) {
      // if the selected range is greater than 2, we are talking about months
      if (selectedRange > 2) {
        // we split it by 4 to get the amount of months
        const dateSend = moment.utc().subtract(selectedRange / 4, "months");
        handleStartDateInput(dateSend);
      } else {
        // if the selected range is 0, we are talking about lifetime.
        // this was just an arbitrary way to refer to the lifetime, the 0
        if (selectedRange === 0) {
          const dateSend = moment.utc().subtract(10, "years");
          handleStartDateInput(dateSend);
        } else {
          // else we are just talking about 2 weeks; subtract them
          const dateSend = moment.utc().subtract(selectedRange, "weeks");
          handleStartDateInput(dateSend);
        }
      }
    }
  }, [selectedRange]);

  /**
   * CompareVideos
   * @param {*} e
   */
  const handleCompareVideos = () => {
    if (!compareState) return setCompareState(true);
    const firstVideo = videosToFilter.find(
      (element) => element.videoOriginal === videosToCompareState[0]
    );
    const secondVideo = videosToFilter.find(
      (element) => element.videoOriginal === videosToCompareState[1]
    );

    setCompareState(false);

    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        "modal[type]": "watch-multiple-videos-modal",
        firstMedia: JSON.stringify(firstVideo),
        secondMedia: JSON.stringify(secondVideo),
      },
    });
  };

  /**
   * Change start date
   * @param {*} date
   */
  const handleStartDateInput = (date) => {
    if (startDateToShow !== moment(date).format("MMM DD, YYYY")) {
      setCounter(1);
      const format = moment(date).format("YYYY-MM-DD");
      const dateSend = `${format}T20:00:00Z`;
      setInitialDateState(dateSend);
      setStartDateToShow(moment(date).format("MMM DD, YYYY"));
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          fromDate: dateSend,
          pageToShow: 1,
          filtersModal: "",
        },
      });
    }
  };
  /**
   * Change end date
   * @param {*} e
   */
  const handleEndDateInput = (date) => {
    if (endDateToShow !== moment(date).format("MMM DD, YYYY")) {
      setCounter(1);
      const format = moment(date).format("YYYY-MM-DD");
      const dateSend = `${format}T20:00:00Z`;
      setEndDateState(dateSend);
      setEndDateToShow(moment(date).format("MMM DD, YYYY"));
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          toDate: dateSend,
          pageToShow: 1,
          filtersModal: "",
        },
      });
    }
  };

  /**
   * Open filter modal
   */
  const openFilterModal = () => {
    const filters =
      videosToFilter.length > 0
        ? videosToFilter.map((element) => element.displayName)
        : [];

    const filtersNonRepeateds = Array.from(new Set(filters));

    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        "modal[type]": "filter-exercise-videos-modal",
        filtersModal: JSON.stringify(filtersNonRepeateds),
      },
    });
  };

  /**
   * Filter exercises by exercise type
   */
  useEffect(() => {
    console.log("query.exerciseFilters", query.exerciseFilters);
    if (query.exerciseFilters && JSON.parse(query.exerciseFilters).length > 0) {
      const arrayToOrder = videosToFilter.filter((element) =>
        JSON.parse(query.exerciseFilters).includes(element.displayName)
      );
      setVideosToShow(arrayToOrder);
    }
  }, [query.exerciseFilters]);
  const loadMoreVideos = () => {
    setCounter(counter + 1);
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        fromDate: initialDateState,
        toDate: endDateState,
        sortDate: sortState,
        pageToShow: counter + 1,
      },
    });
  };
  const removeFilter = (type) => {
    const newFiltersSet = JSON.parse(query.exerciseFilters).filter(
      (exercise) => exercise !== type
    );
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        exerciseFilters:
          newFiltersSet.length > 0 ? JSON.stringify(newFiltersSet) : "",
        // modal: "",
        // filtersModal: "",
      },
    });
  };
  const getSelectedVideo = (id) => {
    return videosToFilter.find((element) => element.videoOriginal === id);
  };
  const clearAllFilters = () => {
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        exerciseFilters: "",
        modal: "",
        filtersModal: "",
      },
    });
  };

  const handleSelectedRange = (selectedRange) => {
    setSelectedRange(selectedRange);
  };

  const getFormatedDate = (video) => {
    return moment.utc(video.date).format("MMM D, YYYY");
  };
  return (
    <main role="reports-wrapper" className="main-videos">
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(locals?.athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        text="Calendar Day View"
        pathName={locals.pathname}
        classNames="mobile-hidden"
      />
      <article id="video-list" role="report-content">
        <header>
          <hgroup>
            <div
              className={
                comesFromCheckInSummary
                  ? "mobile-hidden flex gap-2 items-center"
                  : "mobile-hidden "
              }
            >
              {comesFromCheckInSummary ? (
                <SvgIcon
                  classNames="cursor-pointer "
                  onClickFn={() => {
                    history.back();
                  }}
                  src={"/img/new-icons/back-button.svg"}
                />
              ) : (
                <></>
              )}

              <h2 className="mobile-hidden">Video List</h2>
            </div>
            <ReportsBackHandler title={"Video List"} locals={locals} />

            <div role="buttons-container" className="mobile-hidden">
              <a
                role="button"
                data-button-type="secondary"
                data-icon
                onClick={openFilterModal}
              >
                <SvgIcon src="/img/new-icons/filter-white.svg" alt="back" />
                <span>Filter exercise</span>
              </a>
              {compareState && (
                <a
                  role="button"
                  data-button-type="secondary"
                  data-icon
                  onClick={() => setCompareState(false)}
                >
                  <img src="/img/new-icons/red-cross-20px.svg" alt="dismiss" />
                  <span>Cancel</span>
                </a>
              )}
              <a
                role="button"
                data-button-type="primary"
                // onClick={() => setCompareState(true)}
                onClick={handleCompareVideos}
                disabled={
                  compareState && videosToCompareState.length < 2
                    ? true
                    : undefined
                }
              >
                Compare Videos
              </a>
            </div>
          </hgroup>
          <hgroup className="only-show-mobile">
            <div role="buttons-container">
              <a
                role="button"
                data-button-type="secondary"
                data-icon
                onClick={openFilterModal}
              >
                <img src="/img/new-icons/filter-white.svg" alt="back" />
                <span>Filter exercise</span>
              </a>
              {compareState && (
                <a
                  role="button"
                  data-button-type="secondary"
                  data-icon
                  onClick={() => setCompareState(false)}
                >
                  <img src="/img/new-icons/red-cross-20px.svg" alt="dismiss" />
                  <span>Cancel</span>
                </a>
              )}
              <button
                data-button-type="primary"
                onClick={handleCompareVideos}
                disabled={
                  compareState && videosToCompareState.length < 2
                    ? true
                    : undefined
                }
                className={compareState && "mobile-hidden"}
              >
                Compare Videos
              </button>
            </div>
          </hgroup>
          <hgroup>
            <div role="calendar-date-selectors" className="mobile-hidden">
              <DateInput
                name="from"
                placeholder="Start Date"
                value={startDateToShow}
                onChange={(e) => handleStartDateInput(e)}
                dontPadding={true}
              />
              <span>to</span>
              <DateInput
                name="to"
                placeholder="End date"
                value={endDateToShow}
                dontPadding={true}
                onChange={(e) => handleEndDateInput(e)}
              />
            </div>
            {query.exerciseFilters ? (
              <FilterChips
                filters={
                  query.exerciseFilters
                    ? JSON.parse(query.exerciseFilters).map((filter) => {
                        return { text: filter, id: filter };
                      })
                    : []
                }
                clearAllFilters={clearAllFilters}
                clearFilter={removeFilter}
              />
            ) : null}
            <IndependentDateRangeComponent
              weeksSelected={selectedRange}
              handleSelectedRange={handleSelectedRange}
              classNames="only-show-mobile"
            />
          </hgroup>
        </header>
        {compareState && (
          <p className="s3 mb-2">
            (Select 2 videos which you would like to compare)
          </p>
        )}
        <section role="table-wrapper">
          <table role="report-table">
            <thead>
              {videosToShow && videosToShow.length > 0 ? (
                <tr>
                  {compareState && <th></th>}
                  <th>Date</th>
                  <th>Exercise Name</th>
                  <th>Protocol</th>
                  <th>Comments</th>
                  <th className="small-th">Status</th>
                  <th className="small-th">Watched</th>
                  <th className="small-th">Video</th>
                </tr>
              ) : (
                <div className="empty-state">
                  <h3>There are no videos to show</h3>
                </div>
              )}
            </thead>
            <VideoListTable
              locals={locals}
              query={query}
              compareState={compareState}
              setVideosToCompareState={setVideosToCompareState}
              initialDateState={initialDateState}
              endDateState={endDateState}
              sortState={sortState}
              previousExercises={previousExercises}
              setPreviousExercises={setPreviousExercises}
              counter={counter}
              setCounter={setCounter}
              videosToShow={videosToShow}
              videosToFilter={videosToFilter}
              setVideosToFilter={setVideosToFilter}
              setVideosToShow={setVideosToShow}
            />
          </table>
        </section>
        {videoLocals && videoLocals.length > 0 && (
          <a
            role="button"
            data-button-type="secondary"
            onClick={loadMoreVideos}
          >
            Show more
          </a>
        )}
      </article>
      <CompareSelected
        label1={"Video 1"}
        label2={"Video 2"}
        selectedItem1={
          videosToCompareState[0]
            ? getFormatedDate(getSelectedVideo(videosToCompareState[0]))
            : null
        }
        selectedItem2={
          videosToCompareState[1]
            ? getFormatedDate(getSelectedVideo(videosToCompareState[1]))
            : null
        }
        compareFunction={handleCompareVideos}
        closeFunction={() => setCompareState(false)}
        compareName={"Videos"}
      />
    </main>
  );
};

export default VideoList;
